import "../src/shared/wrap_ready.js"
import Cookie from "../src/shared/cookie";

window.BSmart = {};

window.addEventListener("DOMContentLoaded", () => {
  window.BSmart.Cookie = new Cookie();
});

import "../../whitelabels/bsmart/assets/javascripts/application.js";
import "../../whitelabels/bsmart/assets/javascripts/page_background.js";
